export type viewManageOrderRowsData = {
  id?: string;
  type?: string;
  source?: string;
  batchCode: string;
  batchId?: string;
  skuDescription: string;
  otherUnitName?: string;
  caseQuantity: number;
  pieceQuantity: number;
  otherUnitQuantity: number;
  actualCaseQuantity: number;
  actualPieceQuantity: number;
  actualOtherUnitQuantity: number;
  casePrice: string;
  price: string;
  otherUnitPrice: string;
  actualAmount: string;
  discount: string;
  finalAmount: string;
  creationTime: string;
  availableStock?: any;
  pricing?: any;
  taxInfo?: any;
  status?: string;
  uom?: string;
  initialCaseQuantity ?: number; 
  initialOtherUnitQuantity ?: number;
  initialPieceQuantity ?: number; 
  freeItem?: boolean;
  caseToPieceQty: number;
  otherToPieceQty: number;
  initialNormalizedQuantity: number;
  skuDiscountInfo?: any;
  minimumOrderQuantity?: number;
  totalConvertedCasesPrimaryOMS?: any;
  discountInfo?: any[];
  hasChanged?:boolean;
  siteAllSku?:string;
  warehouseAllSku?:string;
  replacementSkuList?:any;
  isNew?:boolean;
  isChecked?:boolean;
  wt?:number;
  alreadySplitted?:boolean;
  lineCount?:number;
  retainId?:string;
  taxAmountCokeNp?:number;
};

export type DiscountDetails = {
  discountApplied: boolean;
  discountValue: string;
  discountType: "VALUE" | "PERCENTAGE" | null;
};

export interface CreateInvoiceModalProps {
  modalOpen: boolean;
  handleModalClose: () => void;
  orderData: any;
  handleOnSave: (invoiceNumber: string) => void;
  discount: DiscountDetails;
  setDiscount: React.Dispatch<React.SetStateAction<DiscountDetails>>;
  invoiceLoading: boolean;
  hideAdditionalDistributorDiscount: boolean;
  orderWillGet?:string;
  hideCouponDiscount?: boolean;
}

export interface CreateInvoiceModalReplacementSKUProps {
  modalOpen: boolean;
  handleModalClose: () => void;
  orderData: any;
  handleOnSave: (invoiceNumber: string) => void;
  discount: DiscountDetails;
  setDiscount: React.Dispatch<React.SetStateAction<DiscountDetails>>;
  invoiceLoading: boolean;
  hideAdditionalDistributorDiscount: boolean;
  originalSkuFulfillmentMap?: Map<string, FulfillmentInfo>; 
  newOrderData?: viewManageOrderRowsData[];
  skuNameMap?:Map<string, string>;
  orderWillGet?:string;
}

export interface EWayBillModalState {
  open: boolean;
  data: string;  
  validationError: boolean;
}

export const eWayBillModalInitialState: EWayBillModalState = {
  open: false,
  data: "",
  validationError: false
};

export interface OutletApprovalDropDownProps {
  approvalStatus: string;
  approvedBy?: string;
  approvedDate?: string;
  approvalReason?: string
}

export type FulfillmentInfo = {
  selfQty: number;
  replacements: Map<string, number>;
  unfulfilled: number;
};
